import React, { useContext, useEffect, useState } from 'react';
import Modal from 'styled-react-modal'
import { AppContext } from '../../contexts/AppContext';
import styled from "styled-components";
import Colors from '../../helpers/Colors';
import Text from './Text';
import { Box, FormControl, FormControlLabel, FormLabel, makeStyles, Radio, RadioGroup } from "@material-ui/core";
import { updateOrderDeliveryMode } from '../../services/OrderService';
import {
    getAvailableDeliveryPartners,
    getSelectedDeliveryPartnerId
} from "../../helpers/DeliveryPartnerHelper";
import Assets from "../../helpers/assets";
import { SELF_MANAGED_DELIVERY_PARTNER } from "../../helpers/Constants";

const StyledModal = Modal.styled`
width: 42rem;
max-height: 37rem;
display: flex;
align-items: center;
justify-content: center;
background-color: ${Colors.white};
position: absolute;
border-radius: 4.4px;
padding: 66px;
`;

const Container = styled.div`
display: flex;
flex-direction: column;
width: 100%;
align-items: center;
`;

const ButtonContainer = styled.div`
display: flex;
flex-direction: row;
width: 100%;
align-items: center;
justify-content: center;
`;

export function DeliveryToggleConfirmation() {

    const classes = useStyles();

    const { deliveryToggleDialogOpen, setDeliveryToggleDialogOpen, activeDeliveryToggleOrder, setActiveDeliveryToggleOrder, orders, setOrders, available3plPartners } = useContext(AppContext);

    const [selected3PL, setSelected3PL] = useState({});

    const onClose = () => {
        setDeliveryToggleDialogOpen(false);
    }

    const onChangeClick = (toggleOrder) => {
        if (toggleOrder && selected3PL.id) {

            let oldDeliveryPartner = getAvailableDeliveryPartners(
                toggleOrder.deliveryPartnerSelection).find(
                partner => partner.id === getCurrentPartnerId(toggleOrder));

            updateOrderDeliveryMode({
                internalOrderId: toggleOrder.id,
                brandId: toggleOrder.brandInfo.id,
                oldDeliveryPartner: oldDeliveryPartner,
                newDeliveryPartner: selected3PL.id
                === SELF_MANAGED_DELIVERY_PARTNER ? null : selected3PL
            }).then(() => {
                setActiveDeliveryToggleOrder({
                    ...toggleOrder,
                    toggleConfirmed: true
                });
                setOrders(orders.map(order => {
                    if(order.id === toggleOrder.id) {
                        order.tempSelected3pl = selected3PL
                    }
                    return order
                }))
                onClose();
            }).catch((e) => {
                setActiveDeliveryToggleOrder(null);
                onClose();
                console.log(e);
            });
        }
    }

    useEffect(() => {
        setSelected3PL({})
    }, [deliveryToggleDialogOpen])

    const on3PLChange = (value) => {
        setSelected3PL(value);
    }

    const getSelectedPartnerId = (toggleOrder) => {
        if (selected3PL.id) {
            return selected3PL.id
        }
        return getCurrentPartnerId(toggleOrder)
    }

    const getCurrentPartnerId = (toggleOrder) => getSelectedDeliveryPartnerId(
        toggleOrder, available3plPartners);

    return (
        <StyledModal
            isOpen={deliveryToggleDialogOpen}
            onBackgroundClick={onClose}
            onEscapeKeydown={onClose}
        >

            <Container>
                <Box
                >
                    <Text className={classes.titleText}>Changing Delivery Method</Text>
                </Box>
                <Box
                    className={classes.descriptionContainer}
                >
                    <img src={Assets.warningYellow.default} width={20} height={20} alt='' />
                    <Text className={classes.descriptionText}>
                        Be careful, once you change the delivery partner, you may need to cancel previous request manually depending on the partner.
                    </Text>
                </Box>
                {getAvailableDeliveryPartners(
                        activeDeliveryToggleOrder.deliveryPartnerSelection) &&
                    <FormControl className={classes.radioGroup}>
                        <RadioGroup>
                            {getAvailableDeliveryPartners(
                                activeDeliveryToggleOrder.deliveryPartnerSelection).map(
                                (partner, i) => {
                                    if (partner.id === getCurrentPartnerId(
                                            activeDeliveryToggleOrder)
                                        || (getCurrentPartnerId(
                                                activeDeliveryToggleOrder) === null
                                            && partner.id
                                            === SELF_MANAGED_DELIVERY_PARTNER)) {
                                        return <></>
                                    }
                                    return (
                                        <FormControlLabel
                                            value={partner.id}
                                            control={<Radio/>}
                                            label={available3plPartners.get(partner.id)}
                                            key={i}
                                            checked={partner.id
                                                === getSelectedPartnerId(
                                                    activeDeliveryToggleOrder)}
                                            onClick={() => on3PLChange(partner)}
                                            className={i
                                            < getAvailableDeliveryPartners(
                                                activeDeliveryToggleOrder.deliveryPartnerSelection).length
                                            - 1 ? classes.separator : ''}/>
                                    )
                                }
                            )}
                        </RadioGroup>
                    </FormControl>
                }

                <ButtonContainer>
                    <Box
                        className={classes.button}
                        style={{ backgroundColor: Colors.white }}
                        onClick={onClose}
                    >
                        <Text style={{ color: Colors.darkGray }}>CANCEL</Text>
                    </Box>
                    <Box
                        className={classes.button}
                        onClick={() => onChangeClick(activeDeliveryToggleOrder)}
                    >
                        <Text>CHANGE</Text>
                    </Box>
                </ButtonContainer>

            </Container>
        </StyledModal>
    );
}

const useStyles = makeStyles(() => ({
    titleText: {
        marginLeft: 0,
        color: Colors.black,
        fontSize: 24,
        fontFamily: 'DINNextLTPro-Regular',
        fontWeight: '700',
    },
    descriptionText: {
        color: Colors.black,
        fontSize: 18,
        fontFamily: 'DINNextLTPro-Regular',
        fontWeight: '400',
        justifyContent: 'center',
        textAlign: 'center'
    },
    button: {
        flex: 1,
        cursor: 'pointer',
        minHeight: 40,
        maxHeight: 40,
        minWidth: 150,
        marginLeft: 40,
        marginRight: 40,
        marginTop: 50,
        backgroundColor: Colors.boldBlue,
        borderRadius: 5,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        transition: '0.25s transform',
    },
    descriptionContainer: {
        display: "flex",
        alignSelf: "start",
        margin: '8px'
    },
    radioGroup: {
        width: "100%",
        maxHeight: '288px',
        overflowY: 'auto',
        color: Colors.black,
        '& .MuiFormControlLabel-root': {
            height: "72px",
            marginRight: 0
        },
        '& .MuiRadio-root': {
            color: Colors.black
        },
        '& .Mui-checked': {
            color: Colors.boldBlue
        }
    },
    separator: {
        borderBottom: "1px solid #F2F2F2"
    }
}));
